module.exports = __webpack_public_path__ + "img/fishing-phishing.db444e39.svg";